/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorActionLogDto } from '../../models/update-vendor-action-log-dto';
import { VendorActionLogDto } from '../../models/vendor-action-log-dto';

export interface VendorActionLogControllerUpdate$Params {
  id: string;
      body: UpdateVendorActionLogDto
}

export function vendorActionLogControllerUpdate(http: HttpClient, rootUrl: string, params: VendorActionLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorActionLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorActionLogControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorActionLogDto>;
    })
  );
}

vendorActionLogControllerUpdate.PATH = '/api/vendorActionLLog/{id}';
